import { useSearchParams } from 'react-router-dom';
import { Token } from '../models/Token';
import { useEffect, useState } from 'react';
import { validateToken } from '../api/validateToken';

export const SEARCH_PARAM_TOKEN = 'tk';

export const useToken = (sourceContext: string | null) => {
  const [searchParams] = useSearchParams();
  const [token] = useState<Token>(
    searchParams.get(SEARCH_PARAM_TOKEN) as string,
  );
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(
    function () {
      if (!token) {
        setIsValid(false);
        setIsValidating(false);
        return;
      }
      validateToken(token, sourceContext)
        .then((isValid) => setIsValid(isValid))
        .catch(() => setIsValid(false))
        .finally(() => {
          setIsValidating(false);
        });
    },
    [token],
  );

  return {
    token,
    isValid,
    isValidating,
  };
};
